import { useAccountStore } from '@/store/use-account-store';
import { useMarketStore } from '@/store/use-markets-store';
import { useOrdersStore } from '@/store/use-orders-store';
import { formatBigInt, formatNumber } from '@/utils/value-format';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

type Props = {
  orderId: string;
};

export default function TpSl({ orderId }: Props) {
  const address = useAccountStore((state) => state.address);
  const { symbol, tpPrice, slPrice } = useOrdersStore(
    useShallow((state) => {
      const { symbol, tpPrice, slPrice } =
        state.getOrders(address).orders[orderId];
      return { symbol, tpPrice, slPrice };
    }),
  );
  const priceDecimals = useStore(
    useMarketStore(symbol),
    (state) => state.marketSpec.priceDecimals,
  );
  return (
    <div className="flex items-center gap-4">
      <p className="text-ellipsis whitespace-nowrap">
        {formatBigInt(tpPrice, priceDecimals, {
          digits: Number(priceDecimals),
          style: 'currency',
        })}{' '}
        /{' '}
        {formatBigInt(slPrice, priceDecimals, {
          digits: Number(priceDecimals),
          style: 'currency',
        })}
      </p>
    </div>
  );
}
